import React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { compact } from 'lodash'

import './index.styles.css'
export const Timeline = ({ children }: { children: React.ReactNode }) => {
  const validChildren = compact(React.Children.toArray(children))
  const childrenCount = React.Children.count(validChildren)

  if (childrenCount < 2) return children

  return (
    <Box flexDirection="row" paddingLeft="s24" gap="s24">
      <Box width="full" gap="s24">
        {React.Children.map(validChildren, (child, index) => (
          <Box key={index} position="relative" className={'Timeline_timelineBox'}>
            {child}
          </Box>
        ))}
      </Box>
    </Box>
  )
}
